import React from 'react';
import { Flex } from '@chakra-ui/react';
import { jsx as ___EmotionJSX } from "@emotion/react";
/**
 * Common Error Boundary component which by default invokes TrackJS for
 * propagating rendering errors
 */
export class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      error: false
    };
    this.props.onInit && this.props.onInit();
  }
  componentDidCatch(error) {
    var errorHandler = this.props.onError || this.onDefaultError;
    errorHandler(error);

    // Temporarily removing fallback state
    // this.setState({ error });
  }
  onDefaultError(error) {
    var TrackJS = window.TrackJS;
    if (!TrackJS) {
      console.error('TrackJS not found!');
      return;
    }
    if (TrackJS.isInstalled()) {
      TrackJS.track(error);
    } else {
      console.error('TrackJS not installed!');
    }
  }
  render() {
    var currentFallbackContent = this.props.fallbackContent ? this.props.fallbackContent : 'Something went wrong!';
    return this.state.error ? ___EmotionJSX(Flex, null, currentFallbackContent) : this.props.children;
  }
}

/**
 * Error Boundary HOC for integration in non-React environments
 */
export function withErrorBoundary(Component, errorBoundaryProps) {
  if (errorBoundaryProps === void 0) {
    errorBoundaryProps = {};
  }
  var WrappedComponent = props => {
    return ___EmotionJSX(ErrorBoundary, errorBoundaryProps, ___EmotionJSX(Component, props));
  };
  var name = Component.displayName || Component.name;
  WrappedComponent.displayName = "withErrorBoundary" + name;
  return WrappedComponent;
}
export default ErrorBoundary;